<template>
  <div class="scheduler-body">
    <loader :isShow="isLoading" />
    <Scheduler
      @toggle="toggleEvents"
      @submitted="loadRentals"
      @loadRentals="loadRentals"
      class="scheduler"
      @deleteRental="deleteRental"
      @success="load"
      :events="events"
      columnTitle="Rooms"
    >
      <template v-slot:actions>
        <div class="right">
          <v-popover offset="16" :auto-hide="true" placement="bottom-end">
            <button class="select-btn">
              <span>Properties</span>
              <img class="down-arrow" src="@/assets/DownGreyArrow.svg" />
            </button>
            <template slot="popover">
              <div class="gscbm-container">
                <div class="gscbm-top-subcontainer">
                  <input
                    v-model="searchValue"
                    type="text"
                    :placeholder="'Search property'"
                  />
                  <img src="../../assets/SearchIconGrey.svg" />
                </div>
                <div class="gscbm-bottom-subcontainer">
                  <div
                    v-for="property of filteredProperties"
                    :key="property.uuid"
                    :value="property"
                    class="gscbm-item-row"
                  >
                    <input
                      @input="setProperty(property)"
                      type="checkbox"
                      class="gscbm-checkbox"
                    />
                    <div class="gscbm-item-title">
                      {{ property.internalName }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </v-popover>
        </div>
        <Button @click="toggleNewRentalMenu" class="scheduler-new-rental">
          New Rental
        </Button>
        <Button @click="showSyncModal" class="scheduler-sync">
          <span v-if="!smallDevice"> Sync Bookings </span>
          <img class="sync-image" v-else src="../../assets/syncIcon.svg" />
        </Button>
      </template>
      <template v-slot:default="{ event }">
        <span>{{ event.text }}</span>
      </template>
    </Scheduler>
    <new-rental-screen
      @cancel="toggleNewRentalMenu"
      @submitted="submitted"
      v-if="showNewRentalMenu"
    />
    <simple-modal
      :width="450"
      clickToClose
      height="auto"
      name="sync-modal"
      class="simple-modal-small-devices"
      @before-close="beforeSyncModalClose"
    >
      <DoubleSyncModal
        v-if="isDoubleSyncModal"
        @showUploadCSV="showUploadCSV"
        @showSyncAPI="showSyncAPI"
      />
      <SyncModal
        v-else-if="isSyncAPI"
        :properties="properties"
        @hideModal="closeSecondModal"
        @sync-state="isSyncing = $event"
      />
      <UploadCSVModal v-else-if="isUploadCSV" @closeModal="closeSecondModal" />
    </simple-modal>
  </div>
</template>
<script>
import { auth } from '../../Firebase'
import { Button } from 'ant-design-vue'
import Scheduler from '@/components/rentals/Scheduler'
import calls from '@/api/calls'
import moment from 'moment'
import Room from '@/models/room'
import Rental from '@/models/rental'
import Housemate from '@/models/housemate'
import NewRentalScreen from '@/screens/rentals/NewRentalScreen.vue'
import SyncModal from '@/screens/rentals/SyncModal.vue'
import UploadCSVModal from '@/screens/rentals/UploadCSVModal.vue'
import DoubleSyncModal from '@/screens/rentals/DoubleSyncModal.vue'
import Loader from '@/components/Loader.vue'

export default {
  name: 'RentalsCalendarScreen',
  components: {
    Scheduler,
    NewRentalScreen,
    SyncModal,
    DoubleSyncModal,
    UploadCSVModal,
    Loader,
    Button
  },
  data() {
    return {
      properties: [],
      mapped_rentals: {},
      selProperty: null,
      hiddenPriorities: [],
      showNewRentalMenu: false,
      searchValue: '',
      checked: [],
      smallDevice: false,
      isSyncAPI: false,
      isUploadCSV: false,
      isDoubleSyncModal: true,
      isSyncing: false,
      allRooms: [],
      isLoading: true,
      isLoadFavoriteOnly: true,
      year: ''
    }
  },
  computed: {
    filteredProperties() {
      this.properties.sort((a, b) => a.name.localeCompare(b.name))

      if (!this.searchValue) {
        return this.properties
      }
      const regex = new RegExp(this.searchValue, 'gi')
      const filtered = []
      for (const property of this.properties) {
        if (property.internalName.toLowerCase().match(regex)) {
          filtered.push(property)
        }
      }
      if (filtered.length < 1) return this.properties
      return filtered
    },
    selected_rentals() {
      let rentals = []
      if (this.selProperty) {
        for (let i = 0; i < this.checked.length; i++) {
          let id = this.checked[i]
          rentals = [...this.mapped_rentals[id], ...rentals]
        }
        // displays all properties when no checkboxes are selected
        if (this.checked.length == 0) {
          if (Object.keys(this.mapped_rentals).length > 0) {
            rentals = Object.values(this.mapped_rentals).flat()
          }
        }
      }
      //displays all properties when window first loads
      else {
        if (this.checked.length == 0) {
          if (Object.keys(this.mapped_rentals).length > 0) {
            rentals = Object.values(this.mapped_rentals).flat()
          }
        }
      }
      return rentals
    },

    events() {
      const events = []
      let count = 0

      this.selected_rentals.length > 0
        ? this.selected_rentals.map((val) => {
            if (!this.hiddenPriorities.includes(val.priority)) {
              let isAdd = false
              if (this.isLoadFavoriteOnly) {
                if (val.favorite) isAdd = true
                else isAdd = false
              } else isAdd = true

              if (isAdd) {
                events.push({
                  id: `event-${val.housemate.uuid}-${val.room.uuid}-${count}`,
                  start: val.arrival,
                  end: val.departure,
                  text: val.housemate.name,
                  channel: val.channel,
                  property: val.property,
                  propertyName: val.propertyName,
                  confirmationCode: val.confirmationCode,
                  favorite: val.favorite,
                  row: {
                    id: `row-${val.housemate.uuid}-${val.room.uuid}-${count}`,
                    name: val.room.internalName,
                    propertyId: val.propertyId,
                    priority: val.priority,
                    special: val.special,
                    toggled: val.room.toggled,
                    room: val.room.uuid,
                    occupancy: val.occupancy,
                    colorOccupancy: val.colorOccupancy,
                    favorite: val.favorite
                  },
                  room: val.room,
                  housemate: val.housemate,
                  companions: val.companions
                })
                count += 1
              }
            }
          })
        : []
      const result = events.sort((a, b) => {
        if (a.row.name.toLowerCase() < b.row.name.toLowerCase()) return -1
        if (a.row.name.toLowerCase() > b.row.name.toLowerCase()) return 1
        return 0
      })

      return result
    }
  },
  methods: {
    generateId() {
      return (
        Math.random().toString(36).substring(2) +
        new Date().getTime().toString(36)
      )
    },
    showSyncAPI() {
      this.isDoubleSyncModal = false
      this.isSyncAPI = true
      this.isUploadCSV = false
    },
    showUploadCSV() {
      this.isDoubleSyncModal = false
      this.isSyncAPI = false
      this.isUploadCSV = true
    },
    closeSecondModal() {
      this.isDoubleSyncModal = true
      this.isSyncAPI = false
      this.isUploadCSV = false
    },
    beforeSyncModalClose(event) {
      if (this.isSyncing) {
        event.cancel()
      }
    },
    setProperty(property) {
      // Handle the favorite
      if (this.isLoadFavoriteOnly) {
        this.isLoadFavoriteOnly = false
      }

      if (this.checked.includes(property.uuid)) {
        const index = this.checked.indexOf(property.uuid)
        this.checked.splice(index, 1)
      } else {
        this.checked.push(property.uuid)
        this.selProperty = property
      }
    },
    toggleNewRentalMenu() {
      this.showNewRentalMenu = !this.showNewRentalMenu
    },
    submitted() {
      this.toggleNewRentalMenu()
      this.loadRentals()
    },
    toggleEvents(row) {
      if (this.hiddenPriorities.includes(row.priority + 1)) {
        this.hiddenPriorities = this.hiddenPriorities.filter(
          (val) => val != row.priority + 1
        )
        row.toggled = false
      } else {
        this.hiddenPriorities.push(row.priority + 1)
        row.toggled = true
      }

      for (let i = 0; i < this.selected_rentals.length; i++) {
        if (this.selected_rentals[i].room.internalName == row.name) {
          this.selected_rentals[i].room.toggled =
            !this.selected_rentals[i].room.toggled
        }
      }
      this.$forceUpdate()
    },
    async loadRentals(year) {
      if (year) this.year = year

      this.isLoading = true
      let results = await calls.GET(
        'rental/from/calendar',
        `${this.year}/${auth.currentUser.email}`
      )

      this.properties = results.properties
      this.rooms = results.rooms

      //finds all rentals available
      const mapped_rentals = []
      for (let property of this.properties) {
        //this is to add the fake rental later on as an array as well
        mapped_rentals[property.uuid] = []
      }

      let priority = 0 //used to determine sorting on the scheduler grid
      for (let property of this.properties) {
        //fake rental to add space
        const fake_rental = {
          arrival: moment('2000-01-01T00:00:00Z', 'YYYY-MM-DDTHH:mm:ssZ'),
          departure: moment('3000-01-01T00:00:00Z', 'YYYY-MM-DDTHH:mm:ssZ'),
          housemate: { uuid: priority, name: '' },
          room: { uuid: priority, internalName: property.internalName },
          priority: priority,
          special: true,
          occupancy: property.percentage,
          colorOccupancy: property.color,
          favorite: property.favorite,
          propertyId: property.uuid
        }

        //adds the fake rental for a given property
        mapped_rentals[property.uuid].push(fake_rental)

        priority += 1

        //creates a fake room for every single room a property has
        for (let room of this.rooms) {
          if (room.propertyId === property.uuid) {
            //name fake is neccesary to format the fake room in the scheduler later on
            const fake_room = {
              arrival: moment('2000-01-01T00:00:00Z', 'YYYY-MM-DDTHH:mm:ssZ'),
              departure: moment('3000-01-01T00:00:00Z', 'YYYY-MM-DDTHH:mm:ssZ'),
              housemate: { uuid: this.generateId(), name: 'fake' },
              room: { uuid: room.uuid, internalName: room.internalName },
              priority: priority,
              favorite: property.favorite
            }

            mapped_rentals[property.uuid].push(fake_room)
          }
        }

        results.data.map((rental) => {
          if (rental[3] === property.uuid) {
            const arrival =
              rental[1].arrival.split('Z')[0] +
              this.generateUtcoffset(property.utcoffset)
            rental[1].arrival = moment(arrival, 'YYYY-MM-DD')
            const departure =
              rental[1].departure.split('Z')[0] +
              this.generateUtcoffset(property.utcoffset)
            rental[1].departure = moment(departure, 'YYYY-MM-DD')
          }
        })

        for (let datum of results.data) {
          if (datum[3] === property.uuid) {
            let room = datum[0]
            let rental = datum[1]
            let housemate = datum[2]
            let newRental = new Rental(
              new Room(
                room.uuid,
                room.internalName,
                room.marketingName,
                room.code,
                { ...room },
                0,
                'green',
                0
              ),
              new Housemate(
                housemate.uuid,
                housemate.name,
                housemate.email,
                housemate.phone
              ),
              rental.arrival,
              { ...rental }
            )
            newRental.addProperty(property.uuid) //easier to backtrack what property it is from inside other components
            newRental.addPropertyName(property.internalName)
            newRental.addPriority(priority)
            newRental.addFavorite(property.favorite)

            mapped_rentals[property.uuid].push(newRental)
          }
        }
        priority += 1
      }

      this.mapped_rentals = mapped_rentals
      this.$forceUpdate()
      this.isLoading = false

      // Save user token, make sure it will not send the API multiple time, 1 hit a day.
      let dayDifference = 2
      if (localStorage.getItem('refreshTokenDate')) {
        const timeDifference =
          new Date().getTime() -
          parseInt(localStorage.getItem('refreshTokenDate'))
        dayDifference = Math.ceil(timeDifference / (1000 * 3600 * 24))
      }
      if (dayDifference > 1) {
        await calls.AUTH('auth/refresh-token', {
          email: auth.currentUser.email,
          token: auth.currentUser.Aa
        })
        localStorage.setItem(
          'refreshTokenDate',
          new Date().getTime().toString()
        )
      }
    },
    generateUtcoffset(time) {
      switch (time) {
        case -800.0:
          return '-08:00'
        case -700.0:
          return '-07:00'
        case -600.0:
          return '-06:00'
        case 700.0:
          return '07:00'
        case 800.0:
          return '08:00'
      }
    },
    async deleteRental(payload) {
      const confirmationCode = payload.confirmationCode
      await calls.DELETE('rental', `${confirmationCode}`)
      await this.load()
    },
    async load() {
      await this.loadRentals(new Date().getFullYear())
    },
    showSyncModal() {
      this.$modal.show('sync-modal')
    },
    onResize() {
      this.width = window.innerWidth
      if (this.width > 1300) {
        this.smallDevice = false
      } else {
        this.smallDevice = true
      }
    }
  },
  async beforeMount() {
    await this.load()
  },
  mounted() {
    this.onResize()
  },
  created() {
    window.addEventListener('resize', this.onResize)
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style scoped>
.simple-modal-small-devices {
  overflow: auto;
}
.scheduler-body {
  padding: 24px;
  background-color: #f5f6f8;
  overflow: hidden;
  box-sizing: border-box;
  height: calc(100vh - 115px);
  display: flex;
  flex-direction: column;
}

.scheduler-body-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.scheduler {
  background: white;
  border-radius: 4px;
  flex: 1;
  min-height: 0;
}

.scheduler-new-rental,
.scheduler-sync {
  text-decoration: none;
  width: 200px;
  height: 40px;
  background: #66b015;
  border-radius: 4px;
  padding: 2px;
  border: none;
  margin-left: 12px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  text-align: center;
  color: white;
}

.scheduler-new-rental:hover,
.scheduler-sync:hover {
  cursor: pointer;
}

.scheduler-property-select {
  background: #ffffff;
  border: 1px solid #cbd4dc;
  box-sizing: border-box;
  border-radius: 4px;
  width: 120px;
  height: 40px;
  color: #767675;
  padding: 6px;
}

.scheduler-property-select:hover {
  cursor: pointer;
}

.gscbm-container {
  background: white;
  border: 0.5px solid #dfdfdf;
  box-sizing: border-box;
  box-shadow: 0px 4px 16px rgba(43, 45, 55, 0.05);
  border-radius: 4px;
  z-index: 1;
}

.gscbm-bottom-subcontainer {
  max-height: 300px;
  overflow-y: scroll;
}

.gscbm-top-subcontainer {
  position: relative;
  padding: 16px;
  min-width: 208px;
  min-height: 32px;
}

.gscbm-top-subcontainer input {
  border: 1px solid #dfdfdf;
  box-sizing: border-box;
  border-radius: 5px;
  width: 208px;
  height: 32px;
  padding-left: 16px;
}
.gscbm-top-subcontainer img {
  position: absolute;
  right: 24px;
  top: 24px;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

input:focus,
textarea:focus,
select:focus {
  outline: none;
}

.gscbm-item-row {
  display: flex;
  flex-flow: row nowrap;
  border-top: 0.5px solid rgba(216, 222, 228, 0.5);
  border-bottom: 0.5px solid rgba(216, 222, 228, 0.5);
  min-height: 40px;
  align-items: center;
  justify-content: left;
  padding-left: 16px;
}

.gscbm-item-title {
  margin-left: 16px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 13px;
  display: flex;
  align-items: center;
  color: #4a4a4a;
}

/* .right {
  position: absolute;
  bottom: 15px;
  right: 0;
  display: flex;
} */

.right .down-arrow {
  position: absolute;
  right: 10px;
  top: 18px;
}

.right .select-btn {
  position: relative;
  width: 120px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #cbd4dc;
  border-radius: 4px;
  color: #767675;
  font-size: 14px;
  margin-left: 16px;
  margin-right: 16px;
  text-align: left;
  cursor: pointer;
  padding-left: 16px;
}

.v-popover.open .select-btn {
  border: 1px solid #66b015;
  color: #66b015;
}
.v-popover.open .select-btn img {
  transform: rotate(180deg);
}

.sync-image {
  visibility: hidden;
}

@media only screen and (max-width: 1300px) {
  .scheduler-body {
    /* margin-top:25%; */
    padding: 24px 0;
  }

  .scheduler-new-rental {
    font-size: 12px;
    width: 100%;
    padding: 0 8px;
    margin-left: 8px;
    max-width: 100px;
  }

  .right {
    width: 100%;
    margin-left: 8px;
  }

  ::v-deep .trigger {
    width: 100%;
  }

  .right .select-btn {
    width: 100%;
    margin-right: 8px;
    height: fit-content;
    padding: 9px 4px;
    box-sizing: border-box !important;
    margin-left: 0;
  }

  .scheduler-sync {
    margin-left: 8px;
    text-decoration: none;
    width: 100%;
    height: auto;
    background: var(--rentalios-dark);
    border-radius: 4px;
    padding: 4px 12px;
    border: none;
    max-width: 40px;
  }

  .sync-image {
    visibility: visible;
  }
}
</style>
